import React from "react";
import { Flex, Grid } from "@chakra-ui/react";
import { PromotionBox } from "./PromotionBox";

export const PromotionFooter = React.memo(() => {
  return (
    <Flex bgColor="brand.300">
      <Grid
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
        }}
        gap={{ base: 6, md: 4 }}
        p={{ base: 6, md: 8 }}
      >
        <PromotionBox
          src={require("assets/promotion-1.png")}
          url="https://promo.hungfooktong.com/hftcms/index.php?option=com_content&view=article&id=326"
        />
        <PromotionBox
          src={require("assets/promotion-2.png")}
          url="https://www.hungfooktong.com/chickenessence/"
        />
        <PromotionBox
          src={require("assets/promotion-3.png")}
          url="https://www.hungfooktong.com/fishessence/"
        />
        <PromotionBox
          src={require("assets/promotion-4.png")}
          url="https://www.hungfooktong.com/joyousseries/bbcard_index.php"
        />
        <PromotionBox
          src={require("assets/promotion-5.png")}
          url="https://www.hungfooktong.com/store-location/"
        />
        <PromotionBox
          src={require("assets/promotion-6.png")}
          url="https://promo.hungfooktong.com/hftcms/index.php?option=com_content&view=article&id=378"
        />
      </Grid>
    </Flex>
  );
});
